import React, { ComponentPropsWithoutRef } from 'react';
import tw, { TwStyle } from 'twin.macro';
import { StatusTodo } from 'components/Icons/icons/StatusTodo';
import { StatusOpen } from 'components/Icons/icons/StatusOpen';
import { StatusDone } from 'components/Icons/icons/StatusDone';

const Statuses = ['todo', 'open', 'done'] as const;
type Status = (typeof Statuses)[number];

interface Props extends ComponentPropsWithoutRef<'button'> {
  status: Status;
}

interface IStatusButtonStyle {
  style: TwStyle;
  hoverStyle: TwStyle;
  icon: JSX.Element;
}

const StatusButtonStyles: {
  [K in (typeof Statuses)[number]]: IStatusButtonStyle;
} = {
  todo: {
    style: tw`text-neutral-quiet`,
    hoverStyle: tw`hover:text-neutral-moderate hover:bg-neutral-quiet`,
    icon: <StatusTodo />,
  },
  open: {
    style: tw`text-warning-moderate`,
    hoverStyle: tw`hover:text-warning-intense hover:bg-warning-moderate`,
    icon: <StatusOpen />,
  },
  done: {
    style: tw`text-positive-moderate`,
    hoverStyle: tw`hover:text-positive-intense hover:bg-positive-moderate`,
    icon: <StatusDone />,
  },
};

export function StatusButton(props: Props) {
  const { status, disabled, ...rest } = props;
  const { style, hoverStyle, icon } = StatusButtonStyles[status];

  return (
    <button
      disabled={disabled}
      css={[
        tw` flex items-center justify-center rounded-full transition [&>svg]:w-full [&>svg]:h-full`,
        style,
        !disabled && [tw`hover:scale-125`, hoverStyle],
      ]}
      {...rest}
    >
      {icon}
    </button>
  );
}
